export const CalculateGainTypes = {
    WEIGHT: 1,
    SELL: 2,
};
